import React from "react";
import s from "./style.module.css";
import Container from "../Container";
import Button from "../Button";
import cn from "classnames";
import t from "../../typography.module.css";

const Header = ({ title, text, nav }) => {
  return (
    <div className={s.wrap}>
      <div className={s.header}>
        <Container>
          <h1 className={cn(s.title, t.mega)}>{title}</h1>
          <div className={s.text}>{text}</div>
        </Container>
      </div>

      <div className={s.navWrap}>
        <Container>
          <nav className={s.nav}>
            <div className={s.items}>
              {Object.entries(nav.items).map(([key, { url, text }]) => (
                <a key={url} className={s.navItem} href={url}>
                  {text}
                </a>
              ))}
            </div>

            <div className={s.button}>
              <Button
                tag={"a"}
                href={nav.button.url}
                target="_blank"
                rel="noreferrer"
              >
                {nav.button.text}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.597231 0.000904706C0.432722 0.0181466 0.280496 0.0959141 0.170126 0.219112C0.0597567 0.34231 -0.000875383 0.502143 9.55186e-06 0.667544V19.3333C2.51268e-05 19.5101 0.0702678 19.6797 0.195288 19.8047C0.320309 19.9297 0.489869 20 0.666676 20H19.3333C19.5101 20 19.6797 19.9297 19.8047 19.8047C19.9297 19.6797 20 19.5101 20 19.3333V10.0004C20.0012 9.9121 19.9849 9.82439 19.952 9.74242C19.919 9.66044 19.8701 9.58583 19.8081 9.52292C19.7461 9.46001 19.6722 9.41006 19.5907 9.37597C19.5091 9.34187 19.4217 9.3243 19.3333 9.3243C19.245 9.3243 19.1575 9.34187 19.076 9.37597C18.9945 9.41006 18.9206 9.46001 18.8586 9.52292C18.7965 9.58583 18.7476 9.66044 18.7147 9.74242C18.6817 9.82439 18.6654 9.9121 18.6667 10.0004V18.6667H1.33334V1.33417H10C10.0883 1.33542 10.176 1.3191 10.258 1.28615C10.34 1.25321 10.4146 1.20432 10.4775 1.14229C10.5404 1.08026 10.5904 1.00634 10.6245 0.924841C10.6586 0.84334 10.6762 0.755875 10.6762 0.66753C10.6762 0.579185 10.6586 0.49172 10.6245 0.41022C10.5904 0.328719 10.5404 0.254812 10.4775 0.192786C10.4146 0.130759 10.34 0.0818606 10.258 0.048919C10.176 0.0159773 10.0883 -0.000343158 10 0.000904706H0.666676C0.643543 -0.000301569 0.620364 -0.000301569 0.597231 0.000904706ZM13.4861 0.000904706C13.3093 0.0101132 13.1434 0.089169 13.0249 0.220699C12.9064 0.352229 12.845 0.525449 12.8542 0.702252C12.8634 0.879055 12.9424 1.04497 13.074 1.16347C13.2055 1.28198 13.3787 1.34338 13.5556 1.33417H17.7222L8.19445 10.8615C8.06949 10.9868 7.99936 11.1566 7.99948 11.3335C7.9996 11.5105 8.06996 11.6801 8.19509 11.8053C8.32022 11.9304 8.4899 12.0007 8.66686 12.0009C8.84382 12.001 9.01359 11.9309 9.13889 11.8059L18.6667 2.27857V6.44505C18.6654 6.53338 18.6817 6.62109 18.7147 6.70306C18.7476 6.78504 18.7965 6.85965 18.8586 6.92256C18.9206 6.98547 18.9945 7.03543 19.076 7.06953C19.1575 7.10363 19.245 7.12118 19.3333 7.12118C19.4217 7.12118 19.5091 7.10363 19.5907 7.06953C19.6722 7.03543 19.7461 6.98547 19.8081 6.92256C19.8701 6.85965 19.919 6.78504 19.952 6.70306C19.9849 6.62109 20.0012 6.53338 20 6.44505V0.667544C20 0.490746 19.9297 0.321191 19.8047 0.196176C19.6797 0.0711614 19.5101 0.000922383 19.3333 0.000904706H13.5556C13.5324 -0.000301569 13.5092 -0.000301569 13.4861 0.000904706Z"
                    fill="white"
                  />
                </svg>
              </Button>
            </div>
          </nav>
        </Container>
      </div>
    </div>
  );
};

export default Header;
